import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';

import Datatable, { RELOAD_TABLE_TIME } from '../../components/Datatable/';

import {
  getAllUsers,
  removeUsers,
  restoreUsers,
  logoutUsers
} from '../../redux/actions/users';
import TableHeader from '../../components/TableHeader';
import ModalRemoveItem from '../../components/ModalRemoveItem';
import ModalRestoreItem from '../../components/ModalRestoreItem';
import ModalLogoutUserSystem from '../../components/ModalLogoutUserSystem';
import ModalChangeImage from '../../components/ModalChangeImage';
import searchForPermissions from '../../utils/searchForPermissions';
import { idCompany4Case } from '../../utils/defaultPermissions';

function List (props) {
  const users = useSelector(state => state.users);
  const dispatch = useDispatch();
  const sessionUser = useSelector(state => state.authentications.user);
  const company = sessionUser.company._id;
  const currentPermissions = searchForPermissions(
    'submenu',
    props.match.path,
    sessionUser.permissionsGroup.permissions
  );
  const [showTable, setShowTable] = useState(true);
  useEffect(() => {
    if (showTable) {
      setShowTable(false);
      setTimeout(() => setShowTable(true), RELOAD_TABLE_TIME);
    }
  }, [currentPermissions.options]);
  const tableData = users.data.filter(
    item => item.active || currentPermissions.options.r
  );
  const [showModalRemove, setShowModalRemove] = useState(false);
  const [idItemWillRemove, setIdItemWillRemove] = useState('');
  const [nameItemWillRemove, setNameItemWillRemove] = useState('');
  const handleModalConfirmYesRemove = id => {
    setShowModalRemove(false);
    dispatch(removeUsers(id));
  };
  const [showModalRestore, setShowModalRestore] = useState(false);
  const [idItemWillRestore, setIdItemWillRestore] = useState('');
  const [nameItemWillRestore, setNameItemWillRestore] = useState('');
  const handleModalConfirmYesRestore = id => {
    setShowModalRestore(false);
    dispatch(restoreUsers({ _id: id, active: true }));
  };
  const [showModalUserLogout, setShowModalUserLogout] = useState(false);
  const [idItemWillUserLogout, setIdItemWillUserLogout] = useState('');
  const [nameItemWillUserLogout, setNameItemWillUserLogout] = useState('');
  const handleModalConfirmYesUserLogout = id => {
    setShowModalUserLogout(false);
    dispatch(logoutUsers({ _id: id }));
  };
  const [idUserChangeImage, setIdUserChangeImage] = useState('');
  const [titleUserChangeImage, setTitleUserChangeImage] = useState('');
  const [showModalChangeImage, setShowModalChangeImage] = useState(false);
  const handleModalCloseChangeImage = () => {
    setShowModalChangeImage(false);
  };

  useEffect(() => {
    dispatch(getAllUsers(idCompany4Case === company ? {} : { company }));
  }, [dispatch]);

  const columns = [
    {
      title: 'Nome',
      data: 'name',
      render: data => data || '---'
    },
    {
      title: 'E-mail',
      data: 'email',
      render: data => data || '---'
    },
    {
      title: 'Departamento',
      data: 'department.name',
      render: data => data || '---'
    },
    {
      title: 'Empresa',
      data: 'company.name',
      render: data => data || '---'
    },
    {
      title: 'Nome Ext.',
      data: 'nameExtension',
      render: data => data || '---'
    },
    {
      title: 'Tipo',
      data: 'type',
      render: data => {
        if (data === 'S') {
          return 'Supervisor';
        } else if (data === 'O') {
          return 'Operador';
        } else if (data === 'M') {
          return 'Gestor';
        } else {
          return '---';
        }
      }
    },
    {
      title: 'G. de Permissões',
      data: 'permissionsGroup.name',
      render: data => data || '---'
    },
    {
      title: 'Logado',
      data: 'logged',
      className: 'no-export',
      render: data =>
        data.toString() === 'false'
          ? '<i class="fa fa-times text-danger">&nbsp;</i>'
          : '<i class="fa fa-check text-success">&nbsp;&nbsp;</i>'
    },
    {
      title: 'Ações',
      data: '_id',
      orderable: false,
      className: 'no-export',
      render: (data, type, obj) => {
        return `
          <div class="btn-group">
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Trocar Foto" class="btn btn-success button-action button-action-change-image m-1 rounded" ${
                  obj._id === sessionUser._id ? 'disabled=""' : ''
                }><i class="fa fa-images"></i></button>`
          }
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Deslogar" class="btn btn-dark button-action button-action-logout m-1 rounded" ${
                  !obj.logged || obj._id === sessionUser._id
                    ? 'disabled=""'
                    : ''
                }><i class="fa fa-unlink"></i></button>`
          }
          ${
            !(currentPermissions.options.l && currentPermissions.options.u)
              ? ''
              : `<button id="${data}" type="button" title="Editar" class="btn btn-warning button-action button-action-update rounded"><i class="fa fa-edit"></i></button>`
          }
          ${
            !obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.d)
              ? ''
              : `<button id="${data}" type="button" title="Excluir" class="btn btn-danger button-action button-action-delete m-1 rounded"><i class="fa fa-trash"></i></button>`
          }
          ${
            obj.active ||
            !(currentPermissions.options.l && currentPermissions.options.r)
              ? ''
              : `<button id="${data}" type="button" title="Restaurar" class="btn btn-info button-action button-action-restore m-1 rounded"><i class="fas fa-trash-restore-alt"></i></button>`
          }
          </div>`;
      }
    }
  ];

  const buttons = [
    {
      extend: 'copy',
      className: 'btn btn-dark fa fa-copy',
      title: 'Relatorio Copiado',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'excel',
      className: 'btn btn-dark fa fa-file-excel',
      title: 'Relatorio Excel',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'csv',
      className: 'btn btn-dark fa fa-file-csv',
      title: 'Relatorio CSV',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'pdf',
      className: 'btn btn-dark fa fa-file-pdf',
      title: 'Relatorio PDF',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    },
    {
      extend: 'print',
      className: 'btn btn-dark fa fa-file',
      title: 'Relatorio Print',
      exportOptions: {
        columns: 'thead th:not(.no-export)'
      }
    }
  ];

  const handleUpdateButton = id => {
    const url = '/users/edit/' + id;
    dispatch(push(url));
  };

  const handleDeleteButton = dataRow => {
    setNameItemWillRemove(dataRow.name);
    setIdItemWillRemove(dataRow._id);
    setShowModalRemove(true);
  };

  const handleRestoreButton = dataRow => {
    setNameItemWillRestore(dataRow.name);
    setIdItemWillRestore(dataRow._id);
    setShowModalRestore(true);
  };

  const handleLogoutButton = dataRow => {
    setNameItemWillUserLogout(dataRow.name);
    setIdItemWillUserLogout(dataRow._id);
    setShowModalUserLogout(true);
  };

  const handleChangeImageButton = dataRow => {
    setIdUserChangeImage(dataRow._id);
    setTitleUserChangeImage(dataRow.name);
    setShowModalChangeImage(true);
  };

  return (
    <div className="container-fluid">
      <ModalLogoutUserSystem
        showModal={showModalUserLogout}
        handleModalClose={() => setShowModalUserLogout(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesUserLogout(idItemWillUserLogout)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja deslogar do sistema o usuário'}
        nameItemWillUserLogout={nameItemWillUserLogout}
      />
      <ModalRemoveItem
        showModal={showModalRemove}
        handleModalClose={() => setShowModalRemove(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRemove(idItemWillRemove)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja excluir o usuário'}
        nameItemWillRemove={nameItemWillRemove}
      />
      <ModalRestoreItem
        showModal={showModalRestore}
        handleModalClose={() => setShowModalRestore(false)}
        handleModalConfirmYes={() =>
          handleModalConfirmYesRestore(idItemWillRestore)
        }
        titleModal={'Confirmação'}
        bodyModal={'Deseja restaurar o usuário'}
        nameItemWillRestore={nameItemWillRestore}
      />
      <ModalChangeImage
        showModal={showModalChangeImage}
        handleModalClose={handleModalCloseChangeImage}
        user={idUserChangeImage}
        title={titleUserChangeImage}
      />
      <TableHeader
        title={'Usuários'}
        url={'/users/add'}
        updateList={() =>
          dispatch(getAllUsers(idCompany4Case === company ? {} : { company }))
        }
        isFetching={users.isFetching}
        hideAddButton={!currentPermissions.options.c}
        hideUpdateButton={!currentPermissions.options.l}
      />
      {showTable && currentPermissions.options.l && (
        <Datatable
          data={tableData}
          columns={columns}
          buttons={buttons}
          handleUpdateButton={handleUpdateButton}
          handleDeleteButton={handleDeleteButton}
          handleRestoreButton={handleRestoreButton}
          handleLogoutButton={handleLogoutButton}
          handleChangeImageButton={handleChangeImageButton}
        />
      )}
    </div>
  );
}

List.propTypes = {
  match: PropTypes.object
};

export default List;
